import loginStyle from "../../../../../../assets/scss/common/modal/loginModal.module.scss";
import memberStyle from "../../../../../../assets/scss/sub/editMember.module.scss";
import React, {RefObject} from "react";
import {Gender} from "../../../../../../types/user";
import {ValidateStatus} from "../hooks/useSignupValidator";
import {StyleRequestType} from "../../../../../../types/common";
import {useTranslation} from "react-i18next";

interface Props{
    gender: Gender;
    setGender: (_: Gender) => void;
    genderValidate: ValidateStatus;
    setGenderValidate: (_: ValidateStatus) => void;
    styleRequestType: StyleRequestType;
    genderRef?: RefObject<HTMLDivElement>;
}
export function SignupGenderField({gender, setGender, genderValidate, setGenderValidate, styleRequestType, genderRef}:Props){
    const { t } = useTranslation("userInfo");
    const styles = styleRequestType === StyleRequestType.SIGN_UP ? loginStyle :  memberStyle;
    const handleGenderClick = (selectedGender: Gender) => {
        setGender(selectedGender);
        setGenderValidate(ValidateStatus.NONE)
    };

    const getGenderBoxClassName = (selectedGender: string) => {
        return `${styles.genderBox} ${gender === selectedGender ? styles.selected : ''}`;
    };

    const getGenderTextClassName = (selectedGender: string) => {
        return `${styles.genderText} ${gender === selectedGender ? styles.selectedText : ''}`;
    };

    return (
        <div className={styles.selectWrapper} ref={genderRef}>
            <div className={styles.selectTitleWrapper}>
                <span className={styles.highLight}>{t('form.required')}</span>
                <span className={styles.titleText}>{t('form.gender.label')}</span>
            </div>
            <div className={styles.genderBoxWrapper} >
                <button
                    className={getGenderBoxClassName('MALE')}
                    onClick={() => handleGenderClick(Gender.MALE)}
                >
                    <span className={getGenderTextClassName('MALE')}>{t('form.gender.male')}</span>
                </button>
                <button
                    className={getGenderBoxClassName('FEMALE')}
                    onClick={() => handleGenderClick(Gender.FEMALE)}
                >
                    <span className={getGenderTextClassName('FEMALE')}>{t('form.gender.female')}</span>
                </button>
            </div>
            {genderValidate === ValidateStatus.UNFILLED &&
                (<span className={styles.validateText}>{t('edit.warning.gender')}</span>)
            }
        </div>
    )
}